/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshNftMetadataBody
 */
export interface RefreshNftMetadataBody {
    /**
     * 
     * @type {string}
     * @memberof RefreshNftMetadataBody
     */
    trackerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RefreshNftMetadataBody
     */
    isUpdateAll: boolean;
}

/**
 * Check if a given object implements the RefreshNftMetadataBody interface.
 */
export function instanceOfRefreshNftMetadataBody(value: object): value is RefreshNftMetadataBody {
    if (!('isUpdateAll' in value) || value['isUpdateAll'] === undefined) return false;
    return true;
}

export function RefreshNftMetadataBodyFromJSON(json: any): RefreshNftMetadataBody {
    return RefreshNftMetadataBodyFromJSONTyped(json, false);
}

export function RefreshNftMetadataBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshNftMetadataBody {
    if (json == null) {
        return json;
    }
    return {
        
        'trackerId': json['trackerId'] == null ? undefined : json['trackerId'],
        'isUpdateAll': json['isUpdateAll'],
    };
}

export function RefreshNftMetadataBodyToJSON(json: any): RefreshNftMetadataBody {
    return RefreshNftMetadataBodyToJSONTyped(json, false);
}

export function RefreshNftMetadataBodyToJSONTyped(value?: RefreshNftMetadataBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trackerId': value['trackerId'],
        'isUpdateAll': value['isUpdateAll'],
    };
}

